// src/pages/admin/purchasing2.jsx
import React from 'react';
import { ContainerWithSidebar } from 'components/layout';
import Purchase2Page from '../../features/purchasing2/Purchase2Page';

export default function AdminPurchasing2Page() {
  return (
    <ContainerWithSidebar>
      <Purchase2Page />
    </ContainerWithSidebar>
  );
}
